module.exports = __webpack_public_path__ + "static/media/notify-absence-icon.957d21c3.svg";